import { render, staticRenderFns } from "./AddEnrollment.vue?vue&type=template&id=c82fc36e&"
import script from "./AddEnrollment.vue?vue&type=script&lang=js&"
export * from "./AddEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports